/**
 * @generated SignedSource<<71ade494cf8462b9e0da6be455c6c789>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SubscriptionsViewSubscriptionsQuery$variables = Record<PropertyKey, never>;
export type SubscriptionsViewSubscriptionsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SubscriptionList_query">;
};
export type SubscriptionsViewSubscriptionsQuery = {
  response: SubscriptionsViewSubscriptionsQuery$data;
  variables: SubscriptionsViewSubscriptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Literal",
    "name": "searchTerm",
    "value": ""
  },
  {
    "kind": "Literal",
    "name": "sort",
    "value": "ORDERED_AT_DESC"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SubscriptionsViewSubscriptionsQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "SubscriptionList_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SubscriptionsViewSubscriptionsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*: any*/),
        "concreteType": "SubscriptionConnection",
        "kind": "LinkedField",
        "name": "subscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SubscriptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Subscription",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SubscriptionService",
                    "kind": "LinkedField",
                    "name": "subscriptionService",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionServiceReferenceLabel",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomerAccount",
                    "kind": "LinkedField",
                    "name": "customerAccount",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerName",
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customerNumber",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionServiceReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionServiceReferenceUri",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "orderedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activatedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "subscriptions(first:100,searchTerm:\"\",sort:\"ORDERED_AT_DESC\")"
      },
      {
        "alias": null,
        "args": (v0/*: any*/),
        "filters": [
          "searchTerm",
          "sort"
        ],
        "handle": "connection",
        "key": "SubscriptionList_subscriptions",
        "kind": "LinkedHandle",
        "name": "subscriptions"
      }
    ]
  },
  "params": {
    "cacheID": "09adabb2935b85594e63b37a86514ceb",
    "id": null,
    "metadata": {},
    "name": "SubscriptionsViewSubscriptionsQuery",
    "operationKind": "query",
    "text": "query SubscriptionsViewSubscriptionsQuery {\n  ...SubscriptionList_query\n}\n\nfragment SubscriptionListItem_subscription on Subscription {\n  id\n  state\n  customerAccount {\n    customerName\n    customerNumber\n    id\n  }\n  subscriptionService {\n    name\n    id\n  }\n  subscriptionServiceReference\n  subscriptionServiceReferenceLabel\n}\n\nfragment SubscriptionList_query on Query {\n  subscriptions(first: 100, searchTerm: \"\", sort: ORDERED_AT_DESC) {\n    totalCount\n    edges {\n      node {\n        ...TerminateSubscriptionDialog_subscription\n        ...SubscriptionListItem_subscription\n        id\n        state\n        customerAccount {\n          id\n          customerName\n          customerNumber\n        }\n        subscriptionService {\n          id\n          name\n        }\n        subscriptionServiceReference\n        subscriptionServiceReferenceLabel\n        subscriptionServiceReferenceUri\n        orderedAt\n        activatedAt\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment TerminateSubscriptionDialog_subscription on Subscription {\n  id\n  subscriptionService {\n    name\n    id\n  }\n  subscriptionServiceReferenceLabel\n  customerAccount {\n    customerName\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fbde949d181cf5986ebd8b53fe6f5e3a";

export default node;
